// import {
//   createContext,
//   useContext,
//   useRef,
//   useState,
// } from "react";

// const NotificationContext = createContext();

// export const NotificationProvider = ({ children }) => {
//   const [notification, setNotification] = useState(null);

//   const timeoutRef = useRef(null);

//   const showNotification = (data) => {

//     setNotification(data);

//     if (timeoutRef.current) {
//       clearTimeout(timeoutRef.current);
//     }

//     timeoutRef.current = setTimeout(() => {
//       setNotification(null);
//     }, 5000);
//   };

//   return (
//     <NotificationContext.Provider
//       value={{
//         notification,
//         showNotification,
//       }}
//     >
//       {children}
//     </NotificationContext.Provider>
//   );
// };

// export const useNotification = () =>
//   useContext(NotificationContext);



import {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

import FranchisePageServices from "services/FranchiseService";
import NotificationServices from "services/NotificationServices";
import getEmployeeId from "utils/commonAdmin";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const [allNotifications, setAllNotifications] = useState([]);

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  const timeoutRef = useRef(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError(null);

      const id_employee = await getEmployeeId();

      const response =
        await NotificationServices.getAllNotification(
          id_employee
        );

      setAllNotifications(response?.data || []);
    } catch (err) {
      console.error(err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (data) => {
    if (!data) return;

    setNotification(data);

    setAllNotifications((prev) => {
      const exists = prev.some(
        (item) => item.id === data.id
      );

      if (exists) return prev;

      return [data, ...prev];
    });

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setNotification(null);
    }, 5000);
  };

  const updateNotificationStatus = (
    id,
    status
  ) => {
    setAllNotifications((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              status,
            }
          : item
      )
    );

    setNotification((prev) => {
      if (!prev) return prev;

      if (prev.id !== id) return prev;

      return {
        ...prev,
        status,
      };
    });
  };

  const deleteNotification = (id) => {
    setAllNotifications((prev) =>
      prev.filter(
        (item) => item.id !== id
      )
    );

    setNotification((prev) => {
      if (!prev) return prev;

      if (prev.id === id) {
        return null;
      }

      return prev;
    });
  };

  const clearNotification = () => {
    setNotification(null);
  };
  useEffect(() => {
    fetchNotifications();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        notification,
        showNotification,
        clearNotification,
        allNotifications,
        loading,
        error,
        fetchNotifications,
        updateNotificationStatus,
        deleteNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () =>
  useContext(NotificationContext);